import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
    },
    paperRoot: {
      marginTop: 32,
      paddingBottom: theme.spacing(2),
    },
    gridContainer: {
      padding: theme.spacing(2),
    },
    cardCount: {
      display: 'flex',
      background: '#ddd9',
      padding: '10px 15px !important',
      borderRadius: 7,
    },
    marginRight: {
      marginRight: theme.spacing(1.5),
    },
    chipContainer: {
      display: 'flex',
      flexWrap: 'wrap',
      padding: 0,
      paddingRight: theme.spacing(2),
    },
    chip: {
      margin: theme.spacing(0.5),
      marginBottom: 10,
      fontSize: 14,
      fontWeight: 550,
      border: ' 2px dashed #14171A',
      '& span': {
        color: '#fff',
      },
    },
    chipAdd: {
      margin: theme.spacing(0.5),
      marginBottom: 10,
      fontSize: 14,
      fontWeight: 550,
      border: ' 2px dashed #14171A !important',
      '& span': {
        color: '#14171A',
      },
      cursor: 'pointer',
      '& svg': {
        background: ' #14171A',
        color: '#fff',
      },
    },
    classGroup: {
      margin: theme.spacing(0.5),
      marginBottom: 10,
      fontSize: 14,
      fontWeight: 550,
      border: ' 2px dashed #14171A',
      '& span': {
        color: '#14171A',
      },
      color: '#fff',
      cursor: 'pointer',
      '& svg': {
        background: ' #14171A',
        color: '#fff',
      },
    },
    icons: {
      display: 'flex',
      alignItems: 'center',
    },
    scopeFilter: {
      marginLeft: theme.spacing(2),
    },
    label: {
      margin: theme.spacing(1),
      marginRight: 0,
      fontSize: theme.spacing(2),
      color: 'rgba(0, 0, 0, 0.54)',
    },
    deleteIcon: {
      width: 16,
      height: 16,
      background: ' #14171A',
      color: '#fff',
      borderRadius: '50%',

      '&:hover': {
        color: '#fff',
      },
    },
    chipLabel: {
      fontSize: theme.spacing(2),
      fontWeight: 500,
      color: theme.palette.colors.blue,
    },
    chipRoot: {
      minWidth: 150,
      justifyContent: 'space-between',
    },
    iconButton: {
      padding: 0,
    },
  }),
);

export default useStyles;
